import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

/**
 * Checkbox có trạng thái thứ 3 (indeterminate — "đã chọn một phần").
 *
 * `indeterminate` KHÔNG phải attribute HTML, React không set hộ được, nên phải
 * gán qua DOM ref. Cách làm lấy theo IndeterminateCheckbox trong
 * authorization/role/detail/permission/RoleDetailInfoPermission.js — bản sạch
 * nhất đang có trong app.
 */
// geist-accent chỉ tồn tại dưới dạng token Tailwind (tailwind.config.js), không
// có CSS var tương ứng — accent-color cần giá trị màu thật.
const ACCENT = { accentColor: "#006bff" };

const IndeterminateCheckbox = ({ checked = false, indeterminate = false, disabled = false, onChange, title, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !checked && indeterminate;
  }, [checked, indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      title={title}
      onChange={(e) => onChange?.(e.target.checked)}
      style={ACCENT}
      className={`tw-w-3.5 tw-h-3.5 tw-align-middle ${disabled ? "tw-cursor-not-allowed tw-opacity-40" : "tw-cursor-pointer"} ${className}`}
    />
  );
};

IndeterminateCheckbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default IndeterminateCheckbox;
